import { c as _c } from "react/compiler-runtime";
import { RenderHTML } from '@shared/ui-components/render-html/render-html';
import { type MembershipRequirementsBlock } from '../../../../utils/data/graphql/_generated/gql-generated';
import styles from './ethical-code.module.scss';
type EthicalCodeProps = {
  blockData?: MembershipRequirementsBlock;
};
export const EthicalCode = t0 => {
  const $ = _c(10);
  const {
    blockData
  } = t0;
  let t1;
  if ($[0] !== blockData) {
    t1 = blockData?.EthicalCodeAnchorLink && {
      id: blockData.EthicalCodeAnchorLink
    };
    $[0] = blockData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = blockData?.EthicalCodeStepLabel;
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className={styles.wrapper__label}>{t2}</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = blockData?.EthicalCodeDescription;
  let t5;
  if ($[4] !== t4) {
    t5 = <RenderHTML html={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t3 || $[8] !== t5) {
    t6 = <section className={styles.wrapper} {...t1}>{t3}{t5}</section>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};